import React from "react";
import { formatMessage } from "lib/globalize-util";
import { PromptDialog } from "@nuorder/components";

interface IOwnProps {
    open: boolean;
    onConfirm: (value: string) => void;
    onClose: () => void;
    isLoading: boolean;
    disableConfirm?: boolean;
    initialName?: string;
    errorMessage?: string;
}

export const RenameDialog: React.FunctionComponent<IOwnProps> = React.memo(function RenameDialog({
    open,
    onConfirm,
    onClose,
    initialName,
    errorMessage,
    isLoading,
    disableConfirm,
}) {
    return (
        <PromptDialog
            title={formatMessage("Rename")}
            confirmLabel={formatMessage("Name:")}
            open={open}
            onConfirm={onConfirm}
            onClose={onClose}
            initialValue={initialName}
            errorMessage={errorMessage}
            confirmButtonDisabled={disableConfirm}
            isLoading={isLoading}
            customTextForSave={formatMessage("Save")}
            customTextForCancel={formatMessage("Cancel")}
            closeButtonAriaLabel={formatMessage("Close")}
            blankErrorMessage={formatMessage("You can't leave this blank.")}
        />
    );
});
